import { Injectable } from '@angular/core';
import { PolicyService } from 'src/app/modules/policy/policy.service';
import { LoggerService } from 'src/app/services/logger.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import {
  athora_online_help_map,
  base_online_help_map,
  IOnlineHelp,
  online_help_tdb,
  uni20_online_help_map,
  uni30_online_help_map,
} from './online-help.constants';

@Injectable({
  providedIn: 'root',
})
export class OnlineHelpService {
  private _opened: boolean = false;
  private _helpMap: IOnlineHelp[];
  private _selectedMap: IOnlineHelp;

  constructor(private _policyService: PolicyService) {
    this._helpMap = CommonUtils.assign(base_online_help_map);
  }

  get opened(): boolean {
    return this._opened;
  }

  get selectedMap(): IOnlineHelp {
    return this._selectedMap;
  }

  toggle(): void {
    this._opened = !this._opened;
  }

  refreshMap(url: string) {
    let elem: IOnlineHelp = null;
    if (url.includes('operations')) {
      const companyCode = this._policyService.companyId;
      LoggerService.logInfo(this.constructor.name, 'refreshMap', {
        companyCode,
        url,
      });
      switch (companyCode) {
        case '00056':
          this._helpMap = CommonUtils.assign(athora_online_help_map);
          break;
        case '00055':
        case '00043':
          this._helpMap = CommonUtils.assign(uni20_online_help_map);
          break;
        case '00044':
          this._helpMap = CommonUtils.assign(uni30_online_help_map);
          break;
        default:
          this._helpMap = CommonUtils.assign(base_online_help_map);
          break;
      }
      const param = url.split('operations/')[1];
      if (param) {
        elem = this._helpMap.find(
          (x) => x.url.includes('operations') && x.urlParam.includes(param)
        );
      }
    } else {
      elem = this._helpMap.find((x) => url.startsWith(x.url));
    }
    this._selectedMap = elem ? elem : CommonUtils.assign(online_help_tdb);
  }
}
